/**
 * RegisteredScreen — R-20 Phase 6 registry strict mode hook.
 */
import type { ReactNode } from 'react';
import type { MasterScreenId } from '../../registry/masterScreenRegistry.types.js';
import { getMasterScreenEntry } from '../../registry/masterScreenRegistry.js';

const STRICT =
  typeof process !== 'undefined' &&
  (process.env.RETAIL_REGISTRY_STRICT === '1' || process.env.NODE_ENV === 'test');

export interface RegisteredScreenProps {
  readonly screenId: MasterScreenId;
  readonly children: ReactNode;
}

export function RegisteredScreen({ screenId, children }: RegisteredScreenProps): JSX.Element {
  const entry = getMasterScreenEntry(screenId);
  if (entry === undefined) {
    const message = `RegisteredScreen: unknown screenId ${screenId}`;
    if (STRICT) {
      throw new Error(message);
    }
    if (typeof console !== 'undefined') {
      console?.warn(message);
    }
  }
  return <>{children}</>;
}
